import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import 'antd/dist/antd.min.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import client from 'src/apolloClient';
import store from 'src/store';
import './i18n/i18n'; // Import i18n configuration
import TourWrapper from './tourWrapper';

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Provider store={store}>
        <TourWrapper>
          <App />
        </TourWrapper>
      </Provider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
